module.exports = "/fonts/vendor/linearicons/dist/web-Linearicons-Free.woff?a78a26fb0b18bc4cde289816914dd390";